<template>
  <div>
    
    <EditionLieuPortage ref="editionLieuPortage" :lieuDePortage="enEditionLieu" :structures="structures" @enregistrer-lieu="enregistrerLieu($event)" @annuler-edition="fermerModalEdition()" />
    
    <div class="container-fluid">
      <BarreFiltres :filtres="filtres" @appliquer-filtre="appliquerFiltre($event)" />
      <BarreActions :actions="actions" @appliquer-action="executerAction($event)" />

      <div class="card table-scroll height-responsive-100">
        <table class="table table-bordered table-sm text-center table-header">
          <colgroup>
            <col width="300">
            <col>
            <col width="170">
            <col width="400">
            <col width="80">
            <col width="80">
          </colgroup>
          <thead>
            <th class="aligner-gauche">Nom</th>
            <th>Adresse</th>
            <th>Jours ouverture</th>
            <th>Catégories</th>
            <th>Effectifs</th>
            <th>Plat témoin</th>
          </thead>
        </table>
        <div class="table-body">
          <table class="table table-bordered table-sm text-center">
            <colgroup>
              <col width="300">
              <col>
              <col width="170">
              <col width="400">
              <col width="80">
              <col width="75">
            </colgroup>
            <tbody>
              <template v-for="(lieu, iLieu) in lieuxFiltres">
                <!--Ligne du lieu de portage-->
                <tr :class="[{'ligne-selectionnee':lieu.id === idLieuSelectionne}, {'ligne-desactivee':!lieu.actif}]" :key="iLieu" @click="selectionnerLieu(lieu)">
                  <td :rowspan="incrementRowSpan(lieu)" class="aligner-gauche">{{ lieu.libelle }}</td>
                  <td :rowspan="incrementRowSpan(lieu)" class="aligner-gauche">{{ lieu.adresseComplete }}</td>
                  <td :rowspan="incrementRowSpan(lieu)"><p v-if="joursOuverture(lieu)" style="margin-top:10px;">{{joursOuverture(lieu)}}</p></td>
                  <td>{{ lieu.effectifs.length }} dont {{ lieu.nombreEffectifsAZero }} sans effectif</td>
                  <td>{{ lieu.nombreEffectifsTotal }}</td>
                  <td>
                    <i v-if="lieu.effectifAvecPlatTemoin" title="Plat témoin" class="fas fa-check" style="margin-right:2px;vertical-align:middle;"></i>
                  </td>
                </tr>

                <!-- lignes des structures / effectifs-->
                <template v-for="(effectif, iEffectif) in lieu.effectifs.filter(x => x.effectif !== 0)">
                  <tr :key="'lieu-'+iLieu+'-effectif-'+iEffectif" v-if="detaillerEffectifs" :class="[{'ligne-selectionnee':lieu.id === idLieuSelectionne}, {'ligne-desactivee':!lieu.actif}]">
                    <td class="aligner-gauche">
                      {{effectif.structure}} {{effectif.service}} {{effectif.regime}} {{effectif.texture}}
                    </td>
                    <td>
                      {{effectif.effectif}}
                    </td>
                    <td>
                      <i v-if="effectif.aPlatTemoin" title="Plat témoin" class="fas fa-check" style="margin-right:2px;vertical-align:middle;"></i>
                    </td>
                  </tr>
                </template>

              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <b-modal id="modalTriLieux" size="xl" hide-footer header-bg-variant="gradient-bleu" header-text-variant="light" no-close-on-backdrop>
      <template slot="modal-title">
        Ordre des lieux de portage (modification par glisser / déposer)
      </template>
      <template slot="default">
        <div class="row" :key="keyTri">
          <div class="col-xl-3 col-lg-4 col-md-6 col-sm-12" v-for="lieu in lieuxTri" :key="lieu.LieuId" @dragstart="dragStart($event, lieu)" @drop="drop($event, lieu)" @dragover="dragOver($event)">
            <div class="card">
              <div :class="[{'card-header bg-gradient-bleu text-white':lieu.Actif}, {'card-header bg-secondary text-white':!lieu.Actif}]" style="border-radius:0;" draggable="true">
                ({{ lieu.Ordre}}) {{ lieu.libelle }}
              </div>
            </div>
          </div>
        </div>
        <div class="form-actions right mt-2">
          <b-button type="submit" variant="success" alt="Enregistrer" style="float:right;" @click="enregistrerTri">Enregistrer</b-button>
          <b-button type="submit" variant="danger" alt="Annuler" style="float:right;margin-right:10px;" @click="annulerTri">Annuler</b-button>
        </div>
      </template>
    </b-modal>

    <b-modal id="modalEditionJours" size="lg" hide-footer header-bg-variant="gradient-bleu" header-text-variant="light" no-close-on-backdrop>
      <template slot="modal-title">
        Modifier les jours d'ouverture des lieux de portage
      </template>
      <template slot="default">
        <table class="table table-bordered table-sm text-center table-header">
          <colgroup>
            <col width="*">
            <col width="80px">
            <col width="80px">
            <col width="80px">
            <col width="80px">
            <col width="80px">
            <col width="80px">
            <col width="80px">
            <col width="80px">
          </colgroup>
          <thead>
            <th>Lieu de portage</th>
            <th>Lundi</th>
            <th>Mardi</th>
            <th>Mercredi</th>
            <th>Jeudi</th>
            <th>Vendredi</th>
            <th>Samedi</th>
            <th>Dimanche</th>
            <th>Actif</th>
          </thead>
        </table>
        <div class="table-body">
          <table class="table table-bordered table-sm text-center">
            <colgroup>
              <col width="*">
              <col width="80px">
              <col width="80px">
              <col width="80px">
              <col width="80px">
              <col width="80px">
              <col width="80px">
              <col width="80px">
              <col width="80px">
            </colgroup>
            <tbody>
              <tr v-for="lieu in lieuxJours" :key="lieu.id">
                <td>{{lieu.libelle}}</td>
                <td><input type="checkbox" :checked="lieu.joursOuverture.includes(1)" @change="jourChanged(lieu, 1, $event.currentTarget.checked)" /></td>
                <td><input type="checkbox" :checked="lieu.joursOuverture.includes(2)" @change="jourChanged(lieu, 2, $event.currentTarget.checked)" /></td>
                <td><input type="checkbox" :checked="lieu.joursOuverture.includes(3)" @change="jourChanged(lieu, 3, $event.currentTarget.checked)" /></td>
                <td><input type="checkbox" :checked="lieu.joursOuverture.includes(4)" @change="jourChanged(lieu, 4, $event.currentTarget.checked)" /></td>
                <td><input type="checkbox" :checked="lieu.joursOuverture.includes(5)" @change="jourChanged(lieu, 5, $event.currentTarget.checked)" /></td>
                <td><input type="checkbox" :checked="lieu.joursOuverture.includes(6)" @change="jourChanged(lieu, 6, $event.currentTarget.checked)" /></td>
                <td><input type="checkbox" :checked="lieu.joursOuverture.includes(0)" @change="jourChanged(lieu, 0, $event.currentTarget.checked)" /></td>
                <td><input type="checkbox" :checked="lieu.actif" @change="jourChanged(lieu, -1, $event.currentTarget.checked)" /></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="form-actions right mt-2">
          <b-button type="submit" variant="success" alt="Enregistrer" style="float:right;" @click="enregistrerJours">Enregistrer</b-button>
          <b-button type="submit" variant="danger" alt="Annuler" style="float:right;margin-right:10px;" @click="fermerJours">Annuler</b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import BarreFiltres from '@/components/Divers/BarreFiltres'
import BarreActions from '@/components/Divers/BarreActions'
import { connecteData } from "@/mixins/connecteData"
import EditionLieuPortage from '@/components/Divers/EditionLieuPortage'
import { obtenirBarquettes } from '@/api/gpao/production'
import { setLieuxPortage, sortLieuxPortage, getLieuxPortage, supprimerLieuPortage, groupeModifLieuxPortage } from '@/api/gpao/user'
import vm from "@/helpers/vm-toolkit-vue"
import { showAlerts } from "@/mixins/alerts"
import _ from "lodash"

export default {
  components: { EditionLieuPortage, BarreFiltres, BarreActions },
  mixins: [ connecteData, showAlerts ],
  name: "PagePortage",
  data() {
    return {
      enAjoutPortage: false,
      detaillerEffectifs: false,
      idLieuSelectionne: null,
      listeBarquettes: [],
      lieux: [],
      structures: [],
      nouveauLieu: {},
      enEditionLieu: {},
      filtreLieux: "",
      lieuxTri: [],
      lieuxJours: [],
      keyTri: 1,
      filtres: {
        recherche: {
          label: "Recherche lieu de portage",
          champ: "input",
          type: "text",
          effacer: "Effacer la recherche",
          selection: "",
          class: "search",
          filtrer(contexte, valeur) {
            let filtre = contexte.filtres.recherche
            if (valeur) {
              filtre.selection = valeur
            }
            contexte.filtreLieux = filtre.selection || ""
          }
        },
        detaillerEffectifs: {
          label: "Détailler les catégories",
          champ: "checkbox",
          selection: false,
          initialiser(contexte) {
            contexte.filtres.detaillerEffectifs.selection = contexte.$store.state.stock.filtresEnMemoire.detailEffectifs
            contexte.filtres.detaillerEffectifs.filtrer(contexte)
          },
          async filtrer(contexte) {
            contexte.detaillerEffectifs = contexte.filtres.detaillerEffectifs.selection
            contexte.$store.commit('stock/setFiltresEnMemoire', {key: 'detailEffectifs', data: contexte.filtres.detaillerEffectifs.selection})
          }
        },
        barreGauche: [],
        barreDroite: [],
        initialiser(contexte) {
          let gauche = [ contexte.filtres.recherche, contexte.filtres.detaillerEffectifs ]
          contexte.filtres.barreGauche = gauche
          contexte.filtres.barreDroite = []
        }
      },
      actions: {
        // Boutons à afficher dans la barre d'action
        // Exemple :
        /*
        nomAction: {
          label: Label affiché sur le bouton (string),
          disabled: Etat actif/inactif par défaut du bouton (bool),
          class: Classe CSS (btn-primary, btn-success, btn-warning ou btn-danger) à appliquer sur le bouton (par défaut : "btn-primary" est appliqué => il s'agit du bouton bleu Agap'pro) (string)
          methode(contexte) {
            // => contexte équivaut à this (mais this ne fonctionne pas car l'initialisation de data n'est pas encore terminée, donc data n'est pas encore rattaché à this)
            traitements à exécuter lors du clic sur le bouton
            les traitements définis dans cette page doivent être appelés sous la forme : contexte.traitement()

            Remarque : pour que le système fonctionne, il faut déclarer la méthode ci-dessous dans la section "methods" de cette page
            executerAction(methode) {
              methode(this)
            }

          }
        }
        */
        ajouter: {
          label: "Ajouter un lieu",
          async methode(contexte) {
            contexte.ajouterLieu()
          }
        },
        trierLieux: {
          label: "Trier les lieux de portage",
          champ: "btn",
          methode(contexte) {
            contexte.trierLieux()
          }
        },
        modifierJours: {
          label: "Modifier les jours d'ouverture",
          champ: "btn",
          methode(contexte) {
            contexte.modifierJours()
          }
        },
        ouvrir: {
          label: "Ouvrir",
          disabled: true,
          methode(contexte) {
            let l = contexte.lieuSelectionne
            if (l) {
              contexte.modifierLieu(l.id)
            }
          }
        },
        supprimer: {
          label: "Supprimer",
          disabled: true,
          class: "btn-danger",
          methode(contexte) {
            let cmd = contexte.lieuSelectionne
            if (cmd) {
              contexte.supprimerLieu(cmd.id)
            }
          }
        },
        // Appeler "this.actions.initialiser(this)"" dans mounted() => génère les tableaux d'actions utilisés pour afficher les boutons à gauche et à droite de la barre d'actions
        barreGauche: [],
        barreDroite: [],
        initialiser(contexte) {
          contexte.actions.barreGauche = [ contexte.actions.ajouter, contexte.actions.trierLieux, contexte.actions.modifierJours ]
          contexte.actions.barreDroite = [ contexte.actions.ouvrir, contexte.actions.supprimer ]
        },
        // A gérer en cas de boutons à activer/désactiver (créer une méthode par groupe de boutons à activer/désactiver)
        disable(actions, disabled) {
          let actionsATraiter = [ actions.ouvrir, actions.supprimer ]
          actionsATraiter.forEach(a => a.disabled = disabled)
        }
      }
    }
  },
  mounted() {
    this.chargerLieux()
    this.filtres.initialiser(this)
    this.actions.initialiser(this)
  },
  computed: {
    lieuxFiltres() {
      var lieux
      if (!this.filtreLieux) {
        lieux = this.lieux
      } else {
        lieux = this.lieux.filter(lieu => lieu.libelle.toLocaleLowerCase().indexOf(this.filtreLieux.toLocaleLowerCase()) > -1)
      }
      return lieux.sort((a, b) => a.ordreLivraison - b.ordreLivraison)
    },
    lieuSelectionne() {
      return this.lieuxFiltres?.find(c => c.id === this.idLieuSelectionne)
    }
  },
  watch: {
    etabCourant() {
      this.chargerLieux()
    }
  },
  methods: {
    appliquerFiltre(filtrer) {
      filtrer(this)
    },
    executerAction(methode) {
      // Nécessaire pour faire fonctionner les actions de la barre d'actions'
      methode(this)
    },
    incrementRowSpan(lieu) {
      //retourne le nombre de ligne à merger pour l'affichage du fournisseur dans la colonne fournisseur
      return this.detaillerEffectifs ? (lieu.effectifs.filter(x => x.effectif !== 0).length + 1) : 1
    },
    async chargerLieux() {
      var response = await getLieuxPortage(this.etabCourant.eId, true)
      this.lieux = response.data.lieux
      this.structures = response.data.structures
      this.$store.commit('user/setALieuPortage', {eId: this.etabCourant.eId, aLieuPortage: response.data.lieux && response.data.lieux.filter(l => l.actif).length > 0})

      //Chargement des barquettes possibles
      let ret = await obtenirBarquettes(this.etabCourant.eId)
      this.listeBarquettes = ret.data || []

    },
    selectionnerLieu(lieu) {
      if (lieu.id === this.idLieuSelectionne) {
        this.modifierLieu(lieu.id)
        return
      }
      this.idLieuSelectionne = lieu.id
      this.actions.disable(this.actions, !this.lieuSelectionne)
    },
    ajouterLieu() {
      this.nouveauLieu = {
        id: -1,
        etablissementId: this.etabCourant.eId,
        actif: true,
        libelle: 'Nouveau lieu',
        adresse1: '',
        adresse2: '',
        adresse3: '',
        codePostal: '',
        ville: '',
        effectifs: [],
        ordreLivraison: this.lieux.length ? Math.max.apply(Math, this.lieux.map(l => l.ordreLivraison)) + 1 : 1,
        joursOuverture: [],
        barquettes: _.cloneDeep(this.listeBarquettes) //Toutes les barquettes sélectionnées par défaut
      }
      this.$refs.editionLieuPortage.show(this.nouveauLieu, this.listeBarquettes)
    },
    enregistrerLieu(lieu) {
      this.$refs.editionLieuPortage.hide()

      this.enAjoutPortage = false
      this.filtres.initialiser(this)
      return setLieuxPortage([lieu])
        .then(() => {
          this.chargerLieux()
          this.alerteSucces('Lieu enregistré !')
          return
        })
    },
    trierLieux() {
      this.lieuxTri = this.lieux.map(lieu => {
        return {
          LieuId: lieu.id,
          libelle: lieu.libelle,
          Ordre: lieu.ordreLivraison,
          Actif: lieu.actif
        }
      })
      this.lieuxTri.sort((a, b) => a.Ordre - b.Ordre)
      this.$bvModal.show('modalTriLieux')
    },
    dragStart(e, lieu) {
      e.dataTransfer.dropEffect = "move"
      e.dataTransfer.setData("text/plain", lieu.LieuId)
    },
    dragOver(e) {
      e.preventDefault()
    },
    drop(e, destination) {
      e.preventDefault()
      var source = this.lieuxTri.find(l => l.LieuId === Number(e.dataTransfer.getData("text/plain")))
      var ordreDest = destination.Ordre
      if (source.Ordre < destination.Ordre) {
        this.lieuxTri.forEach(lieu => {
          if (lieu.Ordre > source.Ordre && lieu.Ordre <= destination.Ordre && lieu.LieuId !== source.LieuId) {
            lieu.Ordre -= 1
          }
        })
      } else if (source.Ordre > destination.Ordre) {
        this.lieuxTri.forEach(lieu => {
          if (lieu.Ordre < source.Ordre && lieu.Ordre >= destination.Ordre && lieu.LieuId !== source.LieuId) {
            lieu.Ordre += 1
          }
        })
      }
      source.Ordre = ordreDest
      this.lieuxTri = this.lieuxTri.sort((a, b) => a.Ordre - b.Ordre)
    },
    annulerTri() {
      this.$bvModal.hide('modalTriLieux')
    },
    enregistrerTri() {
      this.annulerTri()
      this.lieuxTri.forEach(lieu => {
        this.lieux.find(l => l.id === lieu.LieuId).ordreLivraison = lieu.Ordre
      })
      return sortLieuxPortage(this.lieuxTri)
        .then(() => {
          this.alerteSucces('Tri enregistré !')
          return
        })
    },
    fermerModalEdition() {
      this.$refs.editionLieuPortage.hide()
    },
    async supprimerLieu(lieuId) {
      var lieu = this.lieux.find(x => x.id === lieuId)
      const r = await this.alerteConfirmationSuppression('Supprimer le lieu de portage', "Souhaitez-vous supprimer le lieu de portage \"" + lieu.libelle + "\" ?")
      if (r) {
        return supprimerLieuPortage(lieuId)
          .then(() => {
            this.chargerLieux()
            this.alerteSucces('Lieu supprimé !')
            return
          })
      }
    },
    modifierLieu(lieuId) {
      this.enEditionLieu = vm.clone(this.lieux.find(x => x.id === lieuId))
      this.$refs.editionLieuPortage.show(this.enEditionLieu, this.listeBarquettes)
    },
    joursOuverture(lieu) {
      var txt = ""
      lieu.joursOuverture.forEach(jour => {
        if (jour === 0) {
          txt += (txt ? ", " : "") + "Di"
        } else if (jour === 1) {
          txt += (txt ? ", " : "") + "Lu"
        } else if (jour === 2) {
          txt += (txt ? ", " : "") + "Ma"
        } else if (jour === 3) {
          txt += (txt ? ", " : "") + "Me"
        } else if (jour === 4) {
          txt += (txt ? ", " : "") + "Je"
        } else if (jour === 5) {
          txt += (txt ? ", " : "") + "Ve"
        } else if (jour === 6) {
          txt += (txt ? ", " : "") + "Sa"
        }
      })
      if (txt) {
        //txt = "Ouvert le : " + txt + "."
      }
      return txt
    },
    modifierJours() {
      this.lieuxJours = this.lieux.map(lieu => {
        return {
          lieuId: lieu.id,
          actif: lieu.actif,
          libelle: lieu.libelle,
          joursOuverture: vm.clone(lieu.joursOuverture),
          mod: false
        }
      })
      this.$bvModal.show("modalEditionJours")
    },
    jourChanged(lieu, jour, ouvert) {
      if (jour === -1) {
        lieu.actif = ouvert
        lieu.mod = true
      } else if (ouvert && !lieu.joursOuverture.includes(jour)) {
        lieu.joursOuverture.push(jour)
        lieu.mod = true
      } else if (!ouvert && lieu.joursOuverture.includes(jour)) {
        lieu.joursOuverture.splice(lieu.joursOuverture.indexOf(jour), 1)
        lieu.mod = true
      }
      lieu.joursOuverture = lieu.joursOuverture.sort((a, b) => (a || 7) - (b || 7))
    },
    enregistrerJours() {
      this.fermerJours()
      this.lieuxJours.forEach(lj => {
        var lieu = this.lieux.find(l => l.id === lj.lieuId)
        lieu.joursOuverture = lj.joursOuverture
        lieu.actif = lj.actif
      })
      var mods = this.lieuxJours.filter(j => j.mod)
      if (!mods.length) {
        return
      }
      return groupeModifLieuxPortage(mods)
        .then(() => {
          this.alerteSucces("Jours d'ouverture enregistrés !")
          return
        })
    },
    fermerJours() {
      this.$bvModal.hide("modalEditionJours")
    }
  }
}
</script>
